@if (isVisible) {
  <div class="banner ui-layout-row align-center" [ngStyle]="{'background-color': bgColor}">
    @if (iconVisible) {
      <img src="{{iconPath}}" class="banner-icon">
    }
    <ng-content></ng-content>
    <div class="controls">
      @if (closeButtonVisible) {
        <button mat-button class="dashboard-button confirm" (click)="close()">{{buttonText}}</button>
      }
      @if (closeIconVisible) {
        <img src="assets/svg/close-dialog.svg" class="dialog-close pointer" (click)="close()">
      }
    </div>
  </div>
}
